module.exports = __webpack_public_path__ + "img/icon_cross_w.fd35870f.svg";